





























import Vue from 'vue';
import router from '../../router';
import NavbarComp from '../modules/NavbarComp.vue';
import FooterComp from '../modules/FooterComp.vue';
import ListComp from '../modules/ListComp.vue';
import { APIClient } from '../../libs/ApiClient';

export default Vue.extend({
  name: 'Top',
  components: {
    NavbarComp,
    FooterComp,
    ListComp,
  },
  created() {
    this.getApostilles();
  },
  methods: {
    pushUpload() {
      router.push('upload');
    },
    async getApostilles() {
      this.histories = await APIClient.getApostilles();
      this.isLoading = false;
    }
  },
  data() {
    return {
      isLoading: true,
      rowsPerPageItems: [25],
      hideActions: true,
      histories: [],
      isShowSearch: false,
    };
  }
});
